import React, { useContext, useState } from 'react';
import classNames from 'classnames';
import ProfileImage from '@fiverr-private/profile_image';
import { Rating } from '@fiverr-private/orca';
import { AppContext } from '../../../state/AppContext';
import { reportSellerClicked, reportSellerOverviewHovered } from '../../../utils/report/bigquery';
import { getSellerPagePath } from '../../../../../server/utils/api';
import style from './style.module.scss';

const SellerOverview = () => {
    const storeContext = useContext(AppContext);
    const {
        seller: { name, profileUrl, rating },
    } = storeContext;
    const profileImageUser = {
        username: name,
        has_profile_photo: !!profileUrl,
        profile_photo: profileUrl,
    };
    const [onMouseEnterSent, setOnMouseEnterSent] = useState(false);

    const onMouseEnter = () => {
        if (onMouseEnterSent) {
            return;
        }
        setOnMouseEnterSent(true);

        reportSellerOverviewHovered(storeContext);
    };

    const onClick = () => {
        const redirectUrl = getSellerPagePath(name);

        reportSellerClicked(storeContext);

        window.location.assign(redirectUrl);
    };

    return (
        <span className={style.sellerOverview} onMouseEnter={onMouseEnter}>
            <ProfileImage user={profileImageUser} profileImageSize={40} />
            <span className="m-l-12">
                <a className={classNames(style.sellerUsername, 'text-semi-bold')} onClick={onClick}>
                    {name}
                </a>
                <Rating
                    ratingsCountClassName={style.ratingCount}
                    theme={Rating.THEMES.FIVE_STARS}
                    score={parseFloat(rating.score.toFixed(1))}
                    ratingsCount={rating.count}
                />
            </span>
        </span>
    );
};

export default SellerOverview;
